import * as React from 'react';
import { MainArea } from './mainArea';
import { MainModel } from './../Models/mainModel';
import { loadHomePageData } from './../Actions/homeActions';
import * as renderHTML from 'react-render-html';

declare function require(path: string);
declare var $;
declare var InitializeHeaderImages;

//export interface LayoutProps {
//    children?: React.ReactNode;
//}

export class Home extends React.Component<MainModel, MainModel> {

    public componentDidMount() {
        this.props.dispatch(loadHomePageData());

    }

    public render() {
        return this.props.HomeModel == null ?
            <div className="main-loading-bg" ></div> :
            <div>
                <MainArea HomeModel={this.props.HomeModel} />
                { /* start recent work */}
                <section id="recentWork" className="text-center">
                    <div className="heading">
                        <div className="container">
                            <h2>
                                {renderHTML(this.props.HomeModel.PageDetailsText)}
                            </h2>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </section>
                { /* end recent work  */}

                { /* start setup area */}
                <section className="setupArea">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 home-content">
                                { this.props.HomeModel.PageBigTitle }
                            </div>
                        </div>
                    </div>
                </section>
                { /* end setup area */}
                {this.InitImages()}
            </div>;

    }

    private InitImages(): any {

        setTimeout(() => {
            InitializeHeaderImages();
        });

        return null;

    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/Components/home.tsx